import { useState, useEffect } from 'react';

const useDateValidate = (inputDate) => {
  const [isWithinMonths, setIsWithinMonths] = useState(false);

  useEffect(() => {
    const checkDate = () => {
      const currentDate = new Date();
      const previousDate = new Date();
      previousDate.setMonth(currentDate.getMonth() - 3);

      const selectedDate = new Date(inputDate);

      setIsWithinMonths(selectedDate > previousDate);
    };

    if (inputDate) {
      checkDate();
    }
  }, [inputDate]);

  return isWithinMonths;
};

export default useDateValidate;
